import { KRAKEN_OCTOPUS } from "@/components/PublicLayout";

/**
 * Branded loader using the Coastal Kraken mark.
 * Sizes: sm (28px), md (56px), lg (88px). Centered + pulsing teal glow.
 */
export default function KrakenLoader({ size = "md", label = "Loading…", testId = "kraken-loader" }) {
  const px = size === "sm" ? 28 : size === "lg" ? 88 : 56;
  return (
    <div
      className="flex flex-col items-center justify-center gap-3 py-8"
      role="status"
      aria-live="polite"
      data-testid={testId}
    >
      <img
        src={KRAKEN_OCTOPUS}
        alt=""
        aria-hidden="true"
        width={px}
        height={px}
        className="kraken-loader object-contain select-none"
        style={{ width: px, height: px }}
      />
      {label ? (
        <div className="text-[10px] uppercase tracking-widest text-slate-400">{label}</div>
      ) : null}
      <span className="sr-only">{label || "Loading"}</span>
    </div>
  );
}
